import * as React from "react";
import styles from "./styles.module.css";
import oig from "../../assets/OIG.png";
import { FaChevronCircleLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const Header = ({ title, user = { PictureUrl: "#", DisplayName: "John" } }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.mtn__header}>
      <div className={styles.titleContainer}>
        <span onClick={() => navigate(-1)}>
          <FaChevronCircleLeft />
          &nbsp; Go Back
        </span>
        <h1>
          <b>{title}</b>
        </h1>
      </div>
      <div className={styles.dpContainer}>
        <p>Hi {user?.fullname}</p>
        <div className={styles.dp}>
          <img src={oig} alt={user?.fullname?.slice(0, 1)} />
        </div>
      </div>
    </div>
  );
};

export default Header;
